import { jsx as o } from "react/jsx-runtime";
import { ConditionalWrap as e } from "../components/conditional-wrap/index.js";
import { Text as m } from "@sitecore-jss/sitecore-jss-nextjs";
import { M as s } from "./module-link.BIP-6VCP.js";
const l = ({
  field: r,
  linkUrl: t,
  className: p,
  linkClassName: a,
  tag: n = "span"
}) => !r || !r.value ? null : /* @__PURE__ */ o(
  e,
  {
    condition: !!t,
    wrappedJSX: /* @__PURE__ */ o(m, { tag: n, className: p, field: r }),
    wrapper: (i) => /* @__PURE__ */ o(s, { className: a, href: t, children: i })
  }
);
export {
  l as T
};
